export default "__VITE_ASSET__CsJvkoaz__"